import { createActions } from "redux-actions";

export const {
  getLandingList,
  setLandingList,
  getStopsList,
  setStopsList,
  updateLandingList
} = createActions(
  {
    GET_LANDING_LIST: (orderId, pagination, sort) => ({
      orderId,
      pagination,
      sort
    })
  },
  "SET_LANDING_LIST",
  "GET_STOPS_LIST",
  "SET_STOPS_LIST",
  "UPDATE_LANDING_LIST"
);
